import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { RecordMetadataSchemaDetail } from "./components/RecordMetadataSchemaDetail";
import { RecordMetadataSchemaContainer } from "./components/recordMetadataSchema.container";

function RecordMetadataSchemaDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.recordMetadataSchema.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<PageLoading />}>
      <RecordMetadataSchemaDetail id={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function RecordMetadataSchemaRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<RecordMetadataSchemaContainer />} />
        <Route path=":id" element={<RecordMetadataSchemaDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
